import { useTranslation } from "react-i18next";

export default function Prijzen() {
  const { t } = useTranslation("slotenmaker-eindhoven");
  const rows = t("prijzen.rows", { returnObjects: true }) as Array<{
    label: string;
    value: string;
  }>;

  return (
    <section className="bg-brand-cream py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight mb-6 md:mb-8">
          {t("prijzen.h2")}
        </h2>
        <p className="font-geist text-base md:text-lg text-brand-text/70 max-w-[900px] mb-10 md:mb-14 leading-relaxed">
          {t("prijzen.intro")}
        </p>

        <div className="bg-white rounded-2xl border border-brand-border/60 overflow-hidden max-w-[800px]">
          {rows.map((row, i) => (
            <div
              key={i}
              className={`flex items-center justify-between px-6 md:px-8 py-4 md:py-5 ${
                i !== rows.length - 1 ? "border-b border-brand-border/30" : ""
              } ${i % 2 === 0 ? "bg-white" : "bg-brand-cream/50"}`}
            >
              <span className="font-geist text-sm md:text-base text-brand-text/80">
                {row.label}
              </span>
              <span className="font-geist font-semibold text-sm md:text-base text-brand-text whitespace-nowrap ml-4">
                {row.value}
              </span>
            </div>
          ))}
        </div>

        <p className="font-geist text-sm text-brand-text/60 mt-6 italic">
          {t("prijzen.note")}
        </p>
      </div>
    </section>
  );
}